import {LOAD_ZONE, LOAD_ZONE_FAIL, LOAD_ZONE_SUCCESS} from '../actions/hosting-zones.action';
import {LoadZone, LoadZoneFail, LoadZoneSuccess, ZoneAction} from "../actions";


export interface IHostingZoneState {
  entities: any;
  loading: boolean;
  loaded: boolean;
}

export const initialState: IHostingZoneState = {
  entities: {},
  loading: false,
  loaded: false
};

export function reducer(state: IHostingZoneState = initialState, action: ZoneAction): IHostingZoneState {
  let payload: any;

  switch (action.type) {
    case LOAD_ZONE:
      payload = (<LoadZone>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.zoneId]: {
            ...state[payload.zoneId],
            entities: {},
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_ZONE_SUCCESS:
      payload = (<LoadZoneSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.zoneId]: {
            ...state.entities[payload.zoneId],
            entities: payload.entities,
            loading: false,
            loaded: true
          }
        }
      };

    case LOAD_ZONE_FAIL:
      payload = (<LoadZoneFail>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.zoneId]: {
            ...state.entities[payload.zoneId],
            loading: false,
            loaded: true
          }
        }
      };
  }

  return state;
}
